import React from "react";

const AmbassadorActionPlan = () => {
  const steps = [
    {
      num: 1,
      title: "Share your Konnect link daily:",
      desc: "Blast your custom referral link across WhatsApp status, Instagram stories, TikTok, Facebook, and X.",
    },
    {
      num: 2,
      title: "Refer new Ambassadors:",
      desc: "Focus on creators and peers with active social media followings.",
    },
    {
      num: 3,
      title: "Connect top local stores & restaurants:",
      desc: "Introduce favorite food spots and stores to Konnect. We can issue an official Letter of Introduction.",
    },
    {
      num: 4,
      title: "Engage in WhatsApp Ambassador Group:",
      desc: "Access fresh media assets, daily promotional tasks, and cashback campaigns.",
    },
  ];

  return (
    <div className="w-full bg-white border border-gray-200/80 rounded-3xl p-6 md:p-8 shadow-sm text-left mt-6">
      <h3 className="font-gilroyBold text-2xl text-gray-900 mb-4 m-0">
        Daily Ambassador Action Plan
      </h3>
      <ul className="space-y-4 text-lg text-gray-700 list-none pl-0 m-0">
        {steps.map((s) => (
          <li key={s.num} className="flex items-start gap-3">
            <span className="bg-emerald-100 text-emerald-800 font-gilroyBold w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0">
              {s.num}
            </span>
            <span className="text-lg leading-relaxed pt-0.5">
              <strong className="text-gray-900 font-gilroyBold">{s.title} </strong>
              {s.desc}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AmbassadorActionPlan;
